import { render, staticRenderFns } from "./TransportReports.vue?vue&type=template&id=48afe64a&scoped=true"
import script from "./TransportReports.vue?vue&type=script&lang=js"
export * from "./TransportReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48afe64a",
  null
  
)

export default component.exports